import axios from "axios";

const getPatientDoctorAvailableHours = async (baseUrl, token, patientId, doctorId, selectedDate) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let getResponse = null

    await axios.get(baseUrl + "/patient/" + patientId + "/doctor/" + doctorId + "/hours?appointmentdate=" + selectedDate, config)
        .then((res) => {
            //console.log("res.data: ", res.data)
            getResponse = {
                status: res.data.status,
                result: res.data.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                getResponse = {
                    status: error.response.status,
                    result: error.response.status
                }
            }
        });
    return getResponse
}

export default getPatientDoctorAvailableHours;